module.exports = __webpack_public_path__ + "media/images/slide-13-eb4f917666b45e321cad2339da68b0cb.jpg";